import { render } from "./CreateSpecialPaymentRequestPO.vue?vue&type=template&id=4b53d320&scoped=true"
import script from "./CreateSpecialPaymentRequestPO.vue?vue&type=script&lang=ts"
export * from "./CreateSpecialPaymentRequestPO.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4b53d320"

export default script